import { Button } from "../components/Button";
import { useFlow } from "../flow/FlowContext";
import { useT } from "../i18n";

export function LifestyleScreen() {
  const { answers, setLifestyle, next, canContinue } = useFlow();
  const t = useT();

  return (
    <>
      <div className="screen-enter" style={{ flex: 1 }}>
        <header className="screen-head">
          <div className="screen-head__eyebrow">{t("lifestyle.eyebrow")}</div>
          <h1 className="screen-head__title">{t("lifestyle.title")}</h1>
          <p className="screen-head__text">{t("lifestyle.text")}</p>
        </header>
        <div className="stack">
          <label className="field">
            <span className="field__label">{t("lifestyle.hobbies")}</span>
            <textarea
              className="field__textarea"
              rows={3}
              maxLength={300}
              placeholder={t("lifestyle.hobbiesPlaceholder")}
              value={answers.hobbies}
              onChange={(e) =>
                setLifestyle(
                  e.target.value,
                  answers.reading,
                  answers.profession,
                  answers.lifestyleNotes
                )
              }
            />
          </label>
          <label className="field">
            <span className="field__label">{t("lifestyle.profession")}</span>
            <input
              className="field__input"
              type="text"
              maxLength={120}
              placeholder={t("lifestyle.professionPlaceholder")}
              value={answers.profession}
              onChange={(e) =>
                setLifestyle(
                  answers.hobbies,
                  answers.reading,
                  e.target.value,
                  answers.lifestyleNotes
                )
              }
            />
          </label>
        </div>
      </div>
      <div className="shell__footer" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Button onClick={next} disabled={!canContinue}>
          {t("common.continue")}
        </Button>
      </div>
    </>
  );
}
